.Container {
  border-left: 1px var(--content-border-color) solid;
  display: flex;
  flex-direction: column;
  background-color: var(--app-background);
  height: 100%;
  box-shadow: 0 0.4rem 0.4rem rgba(0, 0, 0, 0.25);

  & > div:not(:last-child) {
    border-bottom: 1px solid var(--content-border-color);
    padding: 0.8rem;
  }
}

.list {
  display: flex;
  flex-direction: column;
  padding: 0.8rem;
  overflow-y: auto;
  min-height: 0;
}

.PanelHeader {
  height: 4rem;
  min-height: 4rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.6rem;
}

.PanelHeaderTitle {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  font-size: 1.4rem;
  color: var(--text-color-white);

  & div:first-child {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 1.6rem;
      height: 1.6rem;
      color: var(--color-texts-high-contrast);
    }

    span {
      font-weight: 500;
    }
  }
}

.EditForm {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  input {
    border: 1px solid var(--content-border-color);
    padding: 0 1.2rem;
    height: 3.2rem;
  }
}

.PanelFooter {
  padding: 0.4rem;
  flex-grow: 1;

  .MenuItem {
    color: #e3e4e7;
    font-size: 1.4rem;
    height: 3.2rem;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0.8rem;
    gap: 0.8rem;
    overflow: hidden;
    cursor: pointer;

    svg {
      min-width: 1.5rem;
    }

    span {
      white-space: nowrap;
    }

    &:hover {
      cursor: pointer;
      background: var(--bg-elevation-2);
    }

    &[data-is-active='true'] {
      background: var(--bg-elevation-2);
    }
  }
}

.DeleteMenuItem {
  color: #db5c66 !important;

  svg {
    color: #db5c66 !important;
  }

  span {
    color: #db5c66 !important;
  }

  &:hover {
    background: rgba(219, 92, 102, 0.1) !important;
  }
}

.DisabledMenuItem {
  color: var(--color-grayscale-manatee) !important;
  cursor: not-allowed !important;

  span {
    color: var(--color-grayscale-manatee) !important;
  }

  &:hover {
    background: transparent !important;
  }
}

.OptionsSection {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}

.EmptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  flex-grow: 1;
}

.OptionsHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.AddOptionButton {
  background: none;
  border: none;
  color: var(--color-texts-high-contrast);
  cursor: pointer;
  padding: 0.4rem;
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;

  svg {
    width: 1.6rem;
    height: 1.6rem;
  }

  &:hover {
    background: var(--color-surfaces-bg-elevation-2);
  }
}

.OptionsList {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.EmptyOptions {
  padding: 2.4rem 1.6rem;
  text-align: center;
  color: var(--color-grayscale-manatee);
  font-size: 1.4rem;
}
